<template>
  <div>
    <main-header-nav
    :title="this.$route.params.from === 'total' ? '全部项目' : '我的项目'"
    :content="'项目详情'"
    :goBack="goBack"
    >
    </main-header-nav>
    <div
      v-loading="costEstimateLoading"
      :element-loading-text="loadingText"
      style="width: 1024px;margin: 0px auto;"
    >
      <el-form
        label-position="right"
        label-width="110px"
        ref="projectInfo"
        :rules="rules"
        :model="formCostEstimate"
        style="width: 1024px;display: inline-block;"
        v-loading="projectDetailsLoading"
      >
        <el-card
          style="width: 1024px;"
        >
          <div
            slot="header"
            style="font-size:20px;margin: 0px 0px 0px 0px;"
          >
            <i class="el-icon-receiving"></i>
            <span>项目基本信息</span>
          </div>
          <el-form-item
            style="width: 300px;margin: 0px 7px 5px 7px;display: inline-block;"
            label="项目模板">
            <el-input
            type="text"
            v-model="formCostEstimate.projectTemplate.name"
            autocomplete="off"
            readonly
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 0px 7px 5px 7px;display: inline-block;"
            label="项目名称"
            prop="name">
            <el-input
            type="text"
            v-model="formCostEstimate.name"
            autocomplete="off"
            placeholder="项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 0px 7px 5px 7px;display: inline-block;"
            label="地区"
            prop="majorMaterialRegionId">
            <el-select
            v-model="formCostEstimate.region.id"
            filterable
            placeholder="请选择地区"
            style="width: 100%;"
            >
              <el-option
                v-for="item in majorMaterialRegions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="地上建筑面积"
            prop="overgroundArea">
            <el-input
                type="text"
                v-model="formCostEstimate.overgroundArea"
                autocomplete="off"
                v-on:input="updateTotalArea"
                placeholder="地上建筑面积"
                @input="updateCostEstimateValue"
                @blur="updateUsageChart"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="地下建筑面积"
            prop="undergroundArea">
            <el-input
                type="text"
                v-model="formCostEstimate.undergroundArea"
                autocomplete="off"
                v-on:input="updateTotalArea"
                placeholder="地下建筑面积"
                @input="updateCostEstimateValue"
                @blur="updateUsageChart"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="工程类别"
            prop="projectLevel">
            <el-select
              style="width: 100%;"
              v-model="formCostEstimate.projectLevel" placeholder="工程类别"
            >
                <el-option
                v-for="item in this.$store.state.projectLevelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="建筑结构"
            prop="buildingStructure">
            <el-select
              style="width: 100%;"
              v-model="formCostEstimate.buildingStructure" placeholder="建筑结构"
            >
                <el-option
                v-for="item in this.$store.state.buildingStructureOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="招标方式"
            prop="biddingType">
            <el-input
                type="text"
                v-model="formCostEstimate.biddingType"
                autocomplete="off"
                placeholder="招标方式"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="报价方式"
            prop="quoteType">
            <el-select
              style="width: 100%;"
              v-model="formCostEstimate.quoteType" placeholder="报价方式"
            >
                <el-option
                v-for="item in this.$store.state.quotationOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            style="width: 300px;margin: 10px 7px 5px 7px;display: inline-block;"
            label="实施时间"
            prop="implementTime">
            <el-date-picker
                v-model="formCostEstimate.implementTime"
                type="date"
                placeholder="实施时间"
                :clearable="false"
                style="width: 100%;"
                >
            </el-date-picker>
          </el-form-item>
        </el-card>
      </el-form>

      <el-card
        v-loading="projectDetailsLoading"
        style="width: 1024px;margin-top: 30px;"
      >
        <div
          slot="header"
          style="font-size:20px;color: #505458;margin: 0px 0px 0px 0px;"
        >
          <i class="el-icon-edit-outline"></i>
          <span>费用信息</span>
        </div>
        <el-form
          ref="formCostEstimate"
          :model="formCostEstimate"
          :rules="costEstimateRules"
        >
          <!-- <div style="width: 500px;text-align: center;font-size: 18px;margin: 30px auto;">
            总建筑面积: {{formCostEstimate.totalArea}}㎡
          </div> -->
          <div
            style="width: 500px;margin: 30px auto 10px;"
          >
            <div style="text-align: left;display: inline-block;font-size: 16px;width: 150px;margin-left: 20px;">
              费用名称
            </div>
            <div style="text-align: center;display: inline-block;font-size: 16px;width: 150px;">
              金额(万元)
            </div>
            <div style="text-align: center;display: inline-block;font-size: 16px;width: 110px;">
              单方造价
            </div>
            <div style="text-align: center;display: inline-block;font-size: 16px;width: 70px;">
              比例(%)
            </div>
          </div>
          <div style="width: 550px;margin: -15px auto -5px;">
            <el-divider></el-divider>
          </div>
          <div
            style="width: 500px;margin: 0px auto 10px;"
          >
            <div style="display: inline-block;width: 170px;font-size: 20px;font-weight: bold;">
              工程总造价
            </div>
            <el-input
              style="width: 150px;"
              :value="(formCostEstimate.totalCost / 10000).toFixed(4)"
              type="text"
              readonly
              autocomplete="off"
              :placeholder="'金额'"
            >
            </el-input>
            <el-input
              style="width: 90px;margin-left: 10px;margin-right: 10px;"
              v-model="totalPerUnitCost"
              type="text"
              readonly=""
              autocomplete="off"
              :placeholder="'单方造价'"
            >
            </el-input>
            <el-input
              style="width: 70px;"
              value="100.0"
              type="text"
              readonly
              autocomplete="off"
              :placeholder="'比例'"
            >
            </el-input>
          </div>
          <el-form-item
            :key="'projectItemCostEstimate' + index"
            v-for='(item, index) of projectItemTreeData'
          >
            <tree-menu-project-item
              ref="projectItemTreeMenu"
              v-on:costChange="updateCostEstimateValue"
              :type="'costEstimate'"
              :item='item'
              :depth='0'
            >
            </tree-menu-project-item>
          </el-form-item>
          <div style="width: 580px;margin: -15px auto -5px;transform: translate(-20px);">
            <el-divider></el-divider>
          </div>
          <div
            style="width: 700px;margin: 0px auto 0px;"
          >
            <div style="display: inline-block;font-size: 19px;width: 255px;text-align: right;">
              项目措施费(技术及组织)
            </div>
            <div style="display: inline-block;width: 15px;"></div>
            <el-form-item
              prop="fee"
              style="display: inline-block;"
            >
              <el-input
                style="width: 150px;"
                :value="(formCostEstimate.fee / 10000).toFixed(4)"
                type="text"
                autocomplete="off"
                :placeholder="'金额'"
                @input="updateCostEstimateValue"
              >
              </el-input>
            </el-form-item>
            <el-input
              style="width: 90px;margin-left: 10px;margin-right: 10px;"
              :value="(formCostEstimate.fee / this.totalArea).toFixed(2)"
              type="text"
              readonly
              autocomplete="off"
              :placeholder="'单方造价'"
            >
            </el-input>
            <el-input
              style="width: 70px;"
               :value="(formCostEstimate.fee / this.$data.formCostEstimate.totalCost * 100).toFixed(2)"
              type="text"
              readonly
              autocomplete="off"
              :placeholder="'比例'"
            >
            </el-input>
          </div>
          <div
            style="width: 700px;margin: -10px auto 10px;"
          >
            <div style="display: inline-block;font-size: 19px;width: 255px;text-align: right;">
              税金
            </div>
            <div style="display: inline-block;width: 15px;"></div>
            <el-form-item
              prop="fee"
              style="display: inline-block;"
            >
              <el-input
                style="width: 150px;"
                :value="(formCostEstimate.tax / 10000).toFixed(4)"
                type="text"
                autocomplete="off"
                :placeholder="'金额'"
                @input="updateCostEstimateValue"
              >
              </el-input>
            </el-form-item>
            <el-input
              style="width: 90px;margin-left: 10px;margin-right: 10px;"
              :value="(formCostEstimate.tax / this.totalArea).toFixed(2)"
              type="text"
              readonly
              autocomplete="off"
              :placeholder="'单方造价'"
            >
            </el-input>
            <el-input
              style="width: 70px;"
              :value="(formCostEstimate.tax / this.$data.formCostEstimate.totalCost * 100).toFixed(2)"
              type="text"
              readonly
              autocomplete="off"
              :placeholder="'比例'"
            >
            </el-input>
          </div>
        </el-form>
      </el-card>

      <el-card style="width: 1024px;margin-top: 30px;">
        <div
          slot="header"
          style="font-size:20px;color: #505458;margin: 0px 0px 0px 0px;"
        >
          <i class="el-icon-data-analysis"></i>
          <span>图表展示</span>
        </div>
        <div>
          <div id='chart' style='display: inline-block;width: 490px;height:400px;margin: 0px auto 0px;'></div>
          <div id='chart0' style='display: inline-block;width: 490px;height:400px;margin: 0px auto 0px;'></div>
        </div>
        <div>
          <div id='chart1' style='display: inline-block;width: 490px;height:400px;margin: 0px auto 0px;'></div>
          <div id='chart2' style='display: inline-block;width: 490px;height:400px;margin: 0px auto 0px;'></div>
        </div>
        <div id='usage_chart' style='width: 960px;height:500px;margin: -10px auto 0px;'></div>
      </el-card>

      <el-form
        v-loading="majorMaterialsUsageLoading"
      >
        <el-card
          style="width: 1024px; margin-top: 30px;">
          <div
            slot="header"
            style="font-size:20px;color: #505458;margin: 0px 0px 0px 0px;"
          >
            <i class="el-icon-s-marketing"></i>
            <span>主要材料用量指标</span>
          </div>
          <div style="width: 520px;margin: 0px auto;">
            <div style="margin-top: 10px;">
              <div style="width: 200px;display: inline-block;">
              </div>
              <div style="width: 200px;display: inline-block;margin-left: 10px;text-align: center;">
                <span>用量</span>
              </div>
              <div style="width: 100px;display: inline-block;margin-left: 10px;text-align: center;">
                <span>单方用量</span>
              </div>
            </div>
            <div style="width: 550px;margin: -15px -20px -5px;">
              <el-divider></el-divider>
            </div>
            <el-form-item
              :key="'majorMaterialUsageCostEstimate' + index" v-for="(majorMaterialUsage, index) of majorMaterialUsageList">
              <div>
                <div style="width: 200px;display: inline-block;">
                  <span>{{majorMaterialUsage.name + '(' + majorMaterialUsage.unit + ')'}}</span>
                </div>
                <el-input
                  type="text"
                  readonly
                  autocomplete="off"
                  :value="totalUsage(majorMaterialUsage.perUnitUsage)"
                  placeholder='用量'
                  style="width: 200px;margin-left: 10px;"
                >
                </el-input>
                <el-input
                  type="text"
                  readonly
                  autocomplete="off"
                  :value="majorMaterialUsage.perUnitUsage"
                  placeholder='单方用量'
                  style="width: 100px;margin-left: 10px;"
                >
                </el-input>
              </div>
            </el-form-item>
          </div>
        </el-card>
        <el-form-item style="margin:30px auto 0px;">
          <el-button
            type="primary"
            style="width: calc(33.33% - 7px);border: none"
            v-on:click="save"
          >更新
          </el-button>
          <el-button
            type="primary"
            style="width: calc(33.33% - 7px);border: none;margin-left:11px;"
            v-on:click="exportExcel"
          >导出Excel
          </el-button>
          <el-button
            type="danger"
            style="width: calc(33.33% - 7px);border: none;"
            v-on:click="remove"
          >删除
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import MainHeaderNav from '../common/MainHeaderNav'
import TreeMenuProjectItem from './TreeMenuProjectItem'
export default {
  name: 'EditProjectCostEstimate',

  components: {
    MainHeaderNav, TreeMenuProjectItem
  },

  data () {
    var self = this

    var validateMajorMaterialRegion = (rule, value, callback) => {
      if (self.formCostEstimate.region.id === undefined) {
        callback(new Error('地区不能为空'))
      } else {
        callback()
      }
    }

    var validateProjectLevel = (rule, value, callback) => {
      if (self.formCostEstimate.projectLevel === undefined) {
        callback(new Error('工程类别不能为空'))
      } else {
        callback()
      }
    }

    var validateBuildingStructure = (rule, value, callback) => {
      if (self.formCostEstimate.buildingStructure === undefined) {
        callback(new Error('建筑结构不能为空'))
      } else {
        callback()
      }
    }

    var validateQuotation = (rule, value, callback) => {
      if (self.formCostEstimate.quoteType === undefined) {
        callback(new Error('报价方式不能为空'))
      } else {
        callback()
      }
    }

    return {
      costEstimateLoading: false,
      loadingText: '',
      projectDetailsLoading: false,
      majorMaterialsUsageLoading: false,
      rules: {
        name: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        majorMaterialRegionId: [
          {
            required: true,
            validator: validateMajorMaterialRegion,
            trigger: ['blur', 'change']
          }
        ],
        overgroundArea: [{ required: true, message: '地上建筑不能为空', trigger: 'blur' }],
        undergroundArea: [{ required: true, message: '地下建筑面积不能为空', trigger: 'blur' }],
        projectLevel: [
          {
            required: true,
            validator: validateProjectLevel,
            trigger: ['blur', 'change']
          }
        ],
        buildingStructure: [
          {
            required: true,
            validator: validateBuildingStructure,
            trigger: ['blur', 'change']
          }
        ],
        quoteType: [
          {
            required: true,
            validator: validateQuotation,
            trigger: ['blur', 'change']
          }
        ],
        implementTime: [{ required: true, message: '实施时间不能为空', trigger: ['blur', 'change'] }]
      },
      costEstimateRules: {
        fee: [{ required: true, message: '项目措施费不能为空', trigger: 'blur' }],
        tax: [{ required: true, message: '税金不能为空', trigger: 'blur' }]
      },
      formCostEstimate: {
        projectTemplate: {},
        name: '',
        region: {},
        totalArea: '',
        overgroundArea: '',
        undergroundArea: '',
        projectLevel: undefined,
        buildingStructure: undefined,
        biddingType: '',
        quoteType: undefined,
        implementTime: undefined,
        projectItemPrices: undefined,
        fee: 0,
        tax: 0,
        totalCost: 0
      },
      projectItems: [],
      projectItemTreeData: [],
      majorMaterials: [],
      majorMaterialsUsage: [],
      majorMaterialRegions: [],
      majorMaterialUsageList: [],
      majorMaterialUsageCheckList: []
    }
  },

  methods: {
    goBack () {
      this.$router.push(this.$route.params.from === 'total' ? '/total_projects' : '/my_projects')
    },

    updateCostEstimateValue () {
      this.updateTotalCost()
      this.updateCostValueAndPercent(this.$data.projectItemTreeData)

      if (this.myChart) {
        this.$echarts.dispose(this.myChart)
      }
      this.myChart = this.$echarts.init(document.getElementById('chart'))
      var option = {
        title: {
          text: '工程造价分析图',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: '45%',
            labelLine: {
              show: true
            },
            data: []
          }
        ]
      }
      for (var i = 0; i < this.$data.projectItemTreeData.length; i++) {
        option.series[0].data.push({ name: this.$data.projectItemTreeData[i].name + '\n(' + this.$data.projectItemTreeData[i].costPercent + '%)', value: this.$data.projectItemTreeData[i].costTotal })
      }
      option.series[0].data.push({ name: '项目措施费' + '\n(' + (this.$data.formCostEstimate.fee / this.$data.formCostEstimate.totalCost * 100).toFixed(2) + '%)', value: this.formCostEstimate.fee })
      option.series[0].data.push({ name: '税金' + '\n(' + (this.$data.formCostEstimate.tax / this.$data.formCostEstimate.totalCost * 100).toFixed(2) + '%)', value: this.formCostEstimate.tax })
      this.myChart.setOption(option, true)

      for (var j = 0; j < 3; j++) {
        if (this['myChart' + j]) {
          this.$echarts.dispose(this['myChart' + j])
        }
        if (!this.$data.projectItemTreeData[j]) {
          continue
        }
        this['myChart' + j] = this.$echarts.init(document.getElementById('chart' + j))
        var option1 = {
          title: {
            text: this.$data.projectItemTreeData[j].name,
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: '45%',
              labelLine: {
                show: true
              },
              data: []
            }
          ]
        }
        var leaves = this.projectUtil.listAllLeafItem(this.$data.projectItemTreeData[j])
        for (var k = 0; k < leaves.length; k++) {
          option1.series[0].data.push({ name: leaves[k].name + '(' + leaves[k].costPercent + '%)', value: leaves[k].costTotal })
        }
        this['myChart' + j].setOption(option1, true)
      }
    },

    updateCostValueAndPercent (projectItems) {
      for (var i = 0; i < projectItems.length; i++) {
        if (projectItems[i].children && projectItems[i].children.length > 0) {
          this.updateCostValueAndPercent(projectItems[i].children)
          var cost = 0
          for (var j = 0; j < projectItems[i].children.length; j++) {
            cost += Number(projectItems[i].children[j].cost)
          }
          this.setCost(projectItems[i], cost.toFixed(2))
        } else {
          this.setCost(projectItems[i], projectItems[i].cost)
        }
      }
    },

    totalUsage (perUnitUsage) {
      return (Number(perUnitUsage) * (Number(this.$data.formCostEstimate.overgroundArea) + Number(this.$data.formCostEstimate.undergroundArea))).toFixed(2)
    },

    updateTotalCost () {
      if (this.totalArea !== '') {
        this.$data.formCostEstimate.totalCost = (this.projectUtil.calcTotalCost(this.$data.projectItemTreeData, this.$data.formCostEstimate.overgroundArea, this.$data.formCostEstimate.undergroundArea) + Number(this.$data.formCostEstimate.tax) + Number(this.$data.formCostEstimate.fee)).toFixed(2)
      }
    },

    updateTotalArea () {

    },

    setCost (item, value) {
      var cost = 0
      var costTotal = 0
      if (item.parentItem) {
        cost = Number(value).toFixed(2)
        this.$set(item, 'cost', cost)
        var areaType = this.projectUtil.getProjectItemAreaType(item)
        var area = this.totalArea
        if (areaType === 1) {
          area = this.$data.formCostEstimate.overgroundArea
        } else if (areaType === 2) {
          area = this.$data.formCostEstimate.undergroundArea
        }
        costTotal = (cost * area).toFixed(2)
        this.$set(item, 'costTotal', costTotal)
      } else {
        for (var i = 0; i < item.children.length; i++) {
          costTotal += Number(item.children[i].costTotal)
        }
        this.$set(item, 'costTotal', Number(costTotal).toFixed(2))
        this.$set(item, 'cost', Number(costTotal / this.totalArea).toFixed(2))
      }
      this.$set(item, 'costPercent', (costTotal / Number(this.$data.formCostEstimate.totalCost) * 100).toFixed(2))
    },

    validateForm () {
      var isAllValid = true
      this.$refs.formCostEstimate.validate((valid) => {
        if (!valid) {
          isAllValid = false
        }
      })
      this.$refs.projectInfo.validate((valid) => {
        if (!valid) {
          isAllValid = false
        }
      })

      if (!isAllValid) {
        this.$message.error({ message: '请完整填写表单' })
        return false
      }

      var resultCost = this.projectUtil.allCostEntered(this.$data.projectItemTreeData)
      if (resultCost === false) {
        this.$message.error({ message: '造价信息未填写完整' })
        return false
      }

      return resultCost
    },

    save () {
      if (!this.formCostEstimate.id) {
        return
      }

      var self = this

      var resultCost = this.validateForm()
      if (resultCost === false) {
        return
      }

      var resultMajorMaterialUsage = []
      for (var i = 0; i < this.$data.majorMaterialUsageList.length; i++) {
        resultMajorMaterialUsage.push(this.$data.majorMaterialUsageList[i].id + ':' + this.totalUsage(this.$data.majorMaterialUsageList[i].perUnitUsage))
      }
      console.log(resultMajorMaterialUsage)

      this.$data.formCostEstimate.projectItemPrices = resultCost.join(',') + '|' + resultMajorMaterialUsage.join(',')

      this.$data.costEstimateLoading = true
      this.$data.loadingText = '保存中，请稍后...'
      this.putRequest('/cost_estimates/edit', this.$data.formCostEstimate)
        .then(resp => {
          self.$data.costEstimateLoading = false
          if (resp && resp.code === 200) {
            self.$message.success({ message: '保存成功' })
          }
        })
    },

    remove () {
      if (!this.formCostEstimate.id) {
        return
      }
      var self = this
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.deleteRequest('/cost_estimates/delete/' + self.formCostEstimate.id)
          .then(resp => {
            if (resp && resp.code === 200) {
              self.$message.success({ message: '删除成功' })
              self.goBack()
            }
          })
      }).catch(() => {
      })
    },

    exportExcel () {
      var self = this

      if (!this.validateForm()) {
        return
      }

      var costEstimate = this.Utils.deepClone(this.$data.formCostEstimate)
      costEstimate.projectLevel = this.$store.state.projectLevelOptions[costEstimate.projectLevel - 1].label
      costEstimate.buildingStructure = this.$store.state.quotationOptions[costEstimate.buildingStructure - 1].label
      costEstimate.quoteType = this.$store.state.quotationOptions[costEstimate.quoteType - 1].label
      costEstimate.overgroundArea = costEstimate.overgroundArea.toFixed(2)
      costEstimate.undergroundArea = costEstimate.undergroundArea.toFixed(2)
      costEstimate.totalArea = this.totalArea.toFixed(2)
      costEstimate.projectItemTreeData = this.$data.projectItemTreeData
      costEstimate.majorMaterialUsageList = self.$data.majorMaterialUsageList
      for (var i = 0; i < costEstimate.majorMaterialUsageList.length; i++) {
        costEstimate.majorMaterialUsageList[i].totalUsage = this.totalUsage(costEstimate.majorMaterialUsageList[i].perUnitUsage)
      }
      this.postRequest('/cost_estimates/export_excel', costEstimate, 'blob')
        .then(resp => {
          var blob = new Blob([resp])
          var fileName = self.$data.formCostEstimate.name + '.xls'
          var eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href) // 释放URL 对象
          document.body.removeChild(eLink)
        })
    },

    updateUsageChart () {
      if (this.usageChart) {
        this.$echarts.dispose(this.usageChart)
      }
      this.usageChart = this.$echarts.init(document.getElementById('usage_chart'))
      var option = {
        color: ['#3398DB'],
        title: [{
          left: 'center',
          top: '0',
          text: '主材金额占比分析图'
        }],
        tooltip: {},
        legend: {},
        grid: {
          x: 20,
          x2: 40,
          y2: 0,
          containLabel: true
        },
        xAxis: {
          axisLabel: {
            rotate: 30,
            interval: 0
          },
          data: []
        },
        yAxis: {
          name: '百分比(%)'
          // data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        },
        series: [{
          type: 'bar',
          label: {
            show: true,
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            distance: 15,
            color: '#000',
            textBorderColor: 'transparent',
            formatter: function (params) {
              return params.value.toString().replace(/\B(?=(\d{3})+\b)/g, ',')
            }
          },
          data: []
        }]
      }
      // var maxUsage = 0
      var leaves = this.projectUtil.listAllLeafItem(this.$data.projectItemTreeData)
      for (var i = 0; i < this.$data.majorMaterialUsageList.length; i++) {
        var majorMaterialUsage = this.$data.majorMaterialUsageList[i]
        option.xAxis.data.push(majorMaterialUsage.name)
        var cost = 0
        for (var j = 0; j < leaves.length; j++) {
          if (leaves[j].majorMaterials) {
            for (var k = 0; k < leaves[j].majorMaterials.length; k++) {
              var majorMaterial = this.getMajorMaterialById(leaves[j].majorMaterials[k].id)
              if (majorMaterial.majorMaterialUsage &&
              majorMaterial.majorMaterialUsage.id === this.$data.majorMaterialUsageList[i].id) {
                cost += leaves[j].costTotal * leaves[j].majorMaterials[k].percent / 100
              }
            }
          }
        }
        option.series[0].data.push((cost / this.$data.formCostEstimate.totalCost * 100).toFixed(2))
        // maxUsage = Math.max(maxUsage, majorMaterial.perUnitUsage * this.totalArea).toFixed(0)
      }
      this.usageChart.setOption(option, true)
    },

    getMajorMaterialById (id) {
      for (var i = 0; i < this.$data.majorMaterials.length; i++) {
        if (this.$data.majorMaterials[i].id === id) {
          return this.$data.majorMaterials[i]
        }
      }
    }
  },

  mounted () {
    var self = this

    this.$data.projectDetailsLoading = true
    var loadedCount = 0
    var loadComplete = function () {
      loadedCount++
      if (loadedCount === 5) {
        self.$data.projectDetailsLoading = false

        var itemList = []
        var itemsWithCost = self.$data.formCostEstimate.projectItemPrices.split('|')[0].split(',')
        for (var j = 0; j < itemsWithCost.length; j++) {
          itemList.push(itemsWithCost[j].split(':')[0])
        }
        self.$data.projectItemTreeData = self.projectUtil.generateProjectItemTreeData(self.$data.projectItems, itemList)
        for (var k = 0; k < itemsWithCost.length; k++) {
          var projectItemData = itemsWithCost[k].split(':')
          var projectItem = self.projectUtil.getProjectItemById(projectItemData[0], self.$data.projectItemTreeData)
          // projectItem.checked = true
          self.setCost(projectItem, projectItemData[1])
        }

        var itemsWithMaterialPercent = self.$data.formCostEstimate.projectTemplate.projectItems.split(',')
        for (k = 0; k < itemsWithMaterialPercent.length; k++) {
          projectItemData = itemsWithMaterialPercent[k].split(':')
          projectItem = self.projectUtil.getProjectItemById(projectItemData[0], self.$data.projectItemTreeData)
          if (projectItemData[2] !== '') {
            projectItem.majorMaterials = []
            var majorMaterials = projectItemData[2].split('|')
            for (var l = 0; l < majorMaterials.length; l++) {
              var percentData = majorMaterials[l].split('-')
              projectItem.majorMaterials.push({ id: parseInt(percentData[0]), percent: percentData[1] })
            }
          }
        }

        var majorMaterialUsageList = self.$data.formCostEstimate.projectItemPrices.split('|')[1].split(',')
        self.$data.majorMaterialUsageList = []
        for (var m = 0; m < majorMaterialUsageList.length; m++) {
          for (var n = 0; n < self.$data.majorMaterialsUsage.length; n++) {
            if (parseInt(majorMaterialUsageList[m].split(':')[0]) === self.$data.majorMaterialsUsage[n].id) {
              self.$data.majorMaterialUsageList.push(self.$data.majorMaterialsUsage[n])
              break
            }
          }
        }

        self.updateUsageChart()

        self.updateCostEstimateValue()
      }
    }

    this.getRequest('/project_items')
      .then(resp => {
        if (resp && resp.result) {
          self.$data.projectItems = resp.result
          loadComplete()
        }
      })

    this.getRequest('/major_materials')
      .then(resp => {
        if (resp && resp.result) {
          self.$data.majorMaterials = resp.result
          loadComplete()
        }
      })

    this.getRequest('/major_material_regions')
      .then(resp => {
        if (resp && resp.result) {
          self.$data.majorMaterialRegions = resp.result
          loadComplete()
        }
      })

    // this.getRequest('/major_materials_usage')
    //   .then(resp => {
    //     if (resp && resp.result) {
    //       self.$data.majorMaterialsUsage = resp.result
    //       loadComplete()
    //     }
    //   })

    this.$data.majorMaterialsUsageLoading = true
    this.getRequest('/cost_estimates/' + this.$route.params.id)
      .then(resp => {
        if (resp && resp.result) {
          for (var key in resp.result) {
            self.$set(self.$data.formCostEstimate, key, resp.result[key])
          }

          loadComplete()

          this.getRequest('/major_materials_usage')
            .then(resp => {
              if (resp && resp.result) {
                self.$data.majorMaterialsUsageLoading = false
                self.$data.majorMaterialsUsage = resp.result
                var projectItemPrices = self.$data.formCostEstimate.projectItemPrices.split('|')
                var majorMaterialsUsage = projectItemPrices[1].split(',')
                for (var i = 0; i < majorMaterialsUsage.length; i++) {
                  var majorMaterialUsage = majorMaterialsUsage[i].split(':')
                  var majorMaterialUsageCheckItem = { id: parseInt(majorMaterialUsage[0]), totalUsage: Number(majorMaterialUsage[1]) }
                  self.$data.majorMaterialUsageCheckList.push(majorMaterialUsageCheckItem)
                  for (var j = 0; j < self.$data.majorMaterialsUsage.length; j++) {
                    if (self.$data.majorMaterialsUsage[j].id === majorMaterialUsageCheckItem.id) {
                      majorMaterialUsageCheckItem.name = self.$data.majorMaterialsUsage[j].name
                      break
                    }
                  }
                }

                loadComplete()
              }
            })
        }
      })
  },

  computed: {
    totalArea () {
      return Number(this.$data.formCostEstimate.overgroundArea) + Number(this.$data.formCostEstimate.undergroundArea)
    },

    totalPerUnitCost () {
      return (Number(this.$data.formCostEstimate.totalCost) / this.totalArea).toFixed(2)
    }
  }
}
</script>
<style scoped>

</style>
